import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import styles from './AmazonPushModal.module.css';

// Backdrop component
const Backdrop = (props) => {
  return <div className={styles.backdrop} onClick={props.onClose} />;
};

// Modal overlay component
const ModalOverlay = (props) => {
  return (
    <div className={styles.modal} style={{ maxWidth: '700px' }}>
      <header className={styles.header}>
        <h2>Amazon Processing Time</h2>
        <button onClick={props.onClose} className={styles.closeButton} aria-label="Close Modal">
          <FaTimes />
        </button>
      </header>
      
      <div className={styles.content}>
        <p style={{ margin: 0, textAlign: 'center', fontSize: '1rem', lineHeight: '1.6' }}>
        Please note Amazon can take <strong>24–48 hours</strong> to reflect your listing updates.<br/>
        You can check the progress anytime on the Manage Amazon Submissions page.<br/>
        Would you like to continue with the submission?
        </p>
        <div style={{ textAlign: 'center', marginTop: '20px', display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button onClick={props.onConfirm} className={styles.yesButton}>
            Yes
          </button>
          <button onClick={props.onClose} className={styles.noButton}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

// Main Modal component using React Portals
const AmazonProcessingTimeModal = (props) => {
  // Check if running in a browser environment before accessing document
  if (typeof window === 'undefined') {
    return null;
  }

  const portalElement = document.getElementById('modal-root');

  // Ensure the portal element exists before attempting to create a portal
  if (!portalElement) {
    return null;
  }

  // Only render if show is true
  if (!props.show) {
    return null;
  }

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay onClose={props.onClose} onConfirm={props.onConfirm} />,
        portalElement
      )}
    </React.Fragment>
  );
};

export default AmazonProcessingTimeModal;
